import { useTranslation } from '@packlink/translation-provider';
import { SectionLayout, Section } from '@shipengine/giger';
import { getServiceDetailsStyles, getServiceDetailsItemsStyles } from './ServiceDetailsStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const ServiceDetails = _ref => {
  let {
    serviceDetails: {
      details,
      info
    }
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsxs(SectionLayout, {
    title: t('service-card.service-details.title'),
    children: [(details === null || details === void 0 ? void 0 : details.length) && jsx(Section, {
      title: t('service-card.service-details.title-details'),
      children: jsx("ul", {
        css: getServiceDetailsStyles,
        children: details.map((detail, index) => jsx("li", {
          css: getServiceDetailsItemsStyles(index === 0),
          children: t(detail)
        }, `service-detail-${index}`))
      })
    }), (info === null || info === void 0 ? void 0 : info.length) && jsx(Section, {
      title: t('service-card.service-details.title-info'),
      children: jsx("ul", {
        css: getServiceDetailsStyles,
        children: info.map((detail, index) => jsx("li", {
          css: getServiceDetailsItemsStyles(index === 0),
          children: t(detail)
        }, `service-detail-info-${index}`))
      })
    })]
  });
};

export { ServiceDetails };
//# sourceMappingURL=ServiceDetails.js.map
